export const SHEET_W_MM = 210;
export const SHEET_H_MM = 297;
export const BADGE_DIAMETER_MM = 44;
export const BLEED_MM = 5;
export const FULL_DIAMETER_MM = BADGE_DIAMETER_MM + 2 * BLEED_MM; // 54
export const COLS = 3;
export const ROWS = 5;
export const DPI = 300;
export const MM_PER_INCH = 25.4;

export const MARGIN_X_MM = (SHEET_W_MM - COLS * FULL_DIAMETER_MM) / 2; // 24
export const MARGIN_Y_MM = (SHEET_H_MM - ROWS * FULL_DIAMETER_MM) / 2; // 13.5

export function slotCentreMm(i: number): { x: number; y: number } {
  const col = i % COLS;
  const row = Math.floor(i / COLS);
  return {
    x: MARGIN_X_MM + FULL_DIAMETER_MM / 2 + col * FULL_DIAMETER_MM,
    y: MARGIN_Y_MM + FULL_DIAMETER_MM / 2 + row * FULL_DIAMETER_MM,
  };
}

export const mmToPt = (mm: number): number => (mm * 72) / MM_PER_INCH;
export const pxAtDpi = (mm: number, dpi: number): number => Math.round((mm * dpi) / MM_PER_INCH);
